import {
  unwrapFieldValue,
  wrapFieldValue,
} from 'features/libra/ontology/ontologyFieldDefaults'
import { EditableNumber } from 'features/libra/stepComponents/niiReport/NiiFieldComponents'
import { useNiiReportData } from 'features/libra/stepComponents/niiReport/NiiReportDataContext'
import {
  DescriptionItem,
  OptionalDescriptions,
} from 'features/libra/stepComponents/niiReport/OptionalDescriptions'
import { FC, memo, useCallback, useMemo } from 'react'

import { StyledCard } from './cardsStyles'

interface NiiInspectionEconomicsCardProps {
  areaField: string
  readonly?: boolean
}

const RawNiiInspectionEconomicsCard: FC<NiiInspectionEconomicsCardProps> = ({
  areaField,
  readonly,
}) => {
  const { localValues, setLocalFieldValue, isLoading } = useNiiReportData()

  const area = unwrapFieldValue<number>(localValues[areaField]) ?? undefined

  const setArea = useCallback(
    (v: number | undefined) => setLocalFieldValue(areaField, wrapFieldValue(v)),
    [areaField, setLocalFieldValue]
  )

  const items = useMemo<ReadonlyArray<DescriptionItem>>(
    () => [
      [
        'Inspectable area (m²)',
        <EditableNumber
          key='area'
          value={area}
          onChange={readonly ? undefined : setArea}
          min={0}
          step={0.1}
          width='200px'
        />,
      ] as const,
    ],
    [area, setArea, readonly]
  )

  return (
    <StyledCard title='Inspection economics'>
      <OptionalDescriptions items={items} isLoading={isLoading} />
    </StyledCard>
  )
}

export const NiiInspectionEconomicsCard = memo(RawNiiInspectionEconomicsCard)
